export default `
  .ReactCollapse--collapse {
    transition: height 500ms;
  }
`;
